<template>
  <div>
    <box-score v-bind:gameId=this.$route.params.gameId></box-score>
    <div class=" is-parent is-12 is-vertical">
      <article class="is-child box">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">Get Official Data:</h1>
              <select class="select is-medium">
                <option>Test</option>
              </select>
        </div>
      </article>
      <article class=" is-child box">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">Goals - {{getTotalCountGoals}}</h1>
          <button class="button is-success is-large">New Item</button>
          <div class="table__wrapper">
            <table class="table is-stripped">
              <thead>
                <th>Team</th>
                <th>Time</th>
                <th>Period</th>
                <th>Situation</th>
                <th>Goal Scorer</th>
                <th>First Assist</th>
                <th>Second Assist</th>
                <th>P1</th>
                <th>P2</th>
                <th>P3</th>
                <th>P4</th>
                <th>P5</th>
                <th>P6</th>
                <th>Verify</th>
                <th>Del</th>
              </thead>
              <tbody>
                <tr v-for="record in CleanGoals" v-bind:key="record.id" v-bind:class="{'other': record.goal_team !== 'Cardiff Devils' ,  'devils': record.goal_team === 'Cardiff Devils'}" @change="updateGoal(record)">
                  <td><input type="text" class="input" disabled v-model="record.goal_team"></td>
                  <td><input type="text" class="input" v-model="record.game_time_global" ></td>
                  <td><input type="text" class="input" v-model="record.period" ></td>
                  <td>
                    <select class="select is-small" v-model="record.situation_id" @change="updateGoal(record)">
                      <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.goal_scorer_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.first_assist_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.second_assist_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_1_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_2_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_3_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_4_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_5_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td>
                    <select class="select is-small" v-model="record.on_ice_6_id" @change="updateGoal(record)">
                      <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                    </select>
                  </td>
                  <td><button class="button is-small" v-bind:class="{'is-success': record.is_verified == 1 ,  'is-danger': record.is_verified == 0}">Verify</button></td>
                  <td><button class="button is-danger is-small">Delete</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
      <article class=" is-child box" style="margin-top:10px;">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">PIMS</h1>
          <button class="button is-success is-large">New Item</button>
          <div class="table__wrapper">
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import BoxScore from '../EditTable/box-score.vue'
import Notification from 'vue-bulma-notification'
import Vue from 'vue'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    Notification,
    'box-score': BoxScore
  },
  computed: {
    getTotalCountGoals () {
      return this.CleanGoals.length
    }
  },
  data () {
    return {
      Goals: [],
      CleanGoals: [],
      HomePlayerOptions: [],
      AwayPlayerOptions: [],
      AllPlayerOptions: [],
      SituationOptions: [],
      PenaltyOptions: []
    }
  },
  methods: {
    fetchData () {
      this.$http.get('https://devilsapi.roblutken.com/api/verify/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(
        response => {
          this.Goals = response.data.goals
          this.CleanGoals = this.cleanGoalData()
          console.log('Data: ' + JSON.stringify(this.CleanGoals))
          if (this.AllPlayerOptions.length <= 0) {
            let homePlayers = response.data.home_players[0]
            let awayPlayers = response.data.away_players[0]
            for (var i = 0; i < homePlayers.length; i++) {
              this.HomePlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
              this.AllPlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
            }
            for (var j = 0; j < awayPlayers.length; j++) {
              this.AwayPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
              if (awayPlayers[j].number > 0) {
                this.AllPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
              }
            }
            let situations = response.data.situations[0]
            for (var k = 0; k < situations.length; k++) {
              this.SituationOptions.push({text: situations[k].secondary_situation, value: situations[k].id})
            }
          }
          let pimOpt = response.data.penalty_options[0]
          for (var l = 0; l < pimOpt.length; l++) {
            this.PenaltyOptions.push({text: pimOpt[l].option, value: pimOpt[l].id})
          }
        }
      )
    },
    updateGoal (record) {
      let editGoal = {
        game_id: this.$route.params.gameId,
        id: record.goal_id,
        period: record.period,
        game_time: record.game_time_global,
        situation_id: record.situation_id,
        goal_scorer: record.goal_scorer_id,
        first_assist: record.first_assist_id,
        second_assist: record.second_assist_id,
        on_ice_1: record.on_ice_1_id,
        on_ice_2: record.on_ice_2_id,
        on_ice_3: record.on_ice_3_id,
        on_ice_4: record.on_ice_4_id,
        on_ice_5: record.on_ice_5_id,
        on_ice_6: record.on_ice_6_id
      }
      console.log(JSON.stringify(editGoal))
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/edit', editGoal,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchData()
      })
    },
    cleanGoalData () {
      let cleanData = []
      // console.log(this.Shots[0])
      _.map(this.Goals[0], function (object) {
        cleanData.push(_.pick(object, ['goal_id', 'goal_team', 'game_time_global', 'period', 'situation_id', 'goal_scorer_id', 'first_assist_id', 'second_assist_id', 'on_ice_1_id', 'on_ice_2_id', 'on_ice_3_id', 'on_ice_4_id', 'on_ice_5_id', 'on_ice_6_id', 'is_verified']))
      })
      return cleanData
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      }).then(
        this.fetchRawGameData()
      )
    }
  },
  created: function () {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
$green: #26681E;
$red: #69140E; 


td{
  min-width: 125px;
}
.devils{
  background-color: $green;
  color:whitesmoke;
}
.other{
  background-color: $red;
  color:whitesmoke;
}

</style>



// WEBPACK FOOTER //
// official-verifier.vue?250a7e14